<template>
  <div class="flex flex-wrap">
    <BCard>
      <div class="grid grid-cols-2 gap-[16px] text-black">
        <div class="flex flex-col border-r border-[#E5E5E5] pr-2">
          <div class="flex gap-[8px] items-center">
            <i class="k-ticket text-primary border-r pr-[8px]" />
            <span class="text-[10px]">Unsolved Ticket</span>
          </div>
          <div class="text-[24px] mt-1">
            {{ unsolvedTicket }}
          </div>
        </div>
        <div class="flex flex-col">
          <div class="flex gap-[8px] items-center">
            <i class="k-clock-1 border-r pr-[8px]" />
            <span class="text-[10px]">Clousure Time</span>
          </div>
          <div class="flex gap-[4px] mt-1">
            <div class="flex gap-[4px] items-baseline">
              <span class="text-[24px]">
                {{ hours }}
              </span>
              <span class="text-[10px]">Hours</span>
            </div>
            <div class="flex gap-[4px] items-baseline">
              <span class="text-[24px]">
                {{ minutes }}
              </span>
              <span class="text-[10px]">Minutes</span>
            </div>
          </div>
        </div>
      </div>
    </BCard>
  </div>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'

export default {
  data() {
    return {
      unsolvedTicket: '00',
      hours: '00',
      minutes: '00',
    }
  },
  mounted() {
    this.getWidgetData()
  },
  methods: {
    async getWidgetData() {
      const url = 'komcards/api/v1/admin/ticket/widget'

      await newAxiosIns
        .get(url)
        .then(res => {
          const data = res?.data?.data
          this.unsolvedTicket = data.unsolved_ticket || '00'
          this.hours = data?.closure_time?.hour || '00'
          this.minutes = data?.closure_time?.minute || '00'
        })
        .catch(err => {
          this.$toast_error({ message: err.response.data.message || 'Gagal mengambil data widget' })
        })
    },
  },
}
</script>
